import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  AdditionalQuestionsObject,
  AdditionalQuestionsProfile,
} from '@app/forms/subscription/definition/interface/Pledge';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import additionalQuestionsForm from '@app/forms/subscription/services/additionalQuestionsForm';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generatForm(entity: AdditionalQuestionsObject): UntypedFormGroup {
    return additionalQuestionsForm.generatForm(entity, this.formBuilder);
  }

  generate(entity: any, option) {
    return additionalQuestionsForm.generatForm(entity, this.formBuilder);
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  get accountInformations() {
    return this.form.get('accountInformations') as UntypedFormArray;
  }
  extract() {
    return { ...this.form.value };
  }
}
